import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { getComponentFromName } from '../../lib/utils';

import * as cards from '../cards';

import styles from '../../../styles/partials/carousel.module.css';

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    index: PropTypes.number,
    active: PropTypes.bool,
    onChange: PropTypes.func,
    willChange: PropTypes.func,
    duration: PropTypes.number,
    transition: PropTypes.number,
    itemType: PropTypes.string,
    className: PropTypes.string,
};

function Carousel({
    items = [],
    index: initialIndex = 0,
    active = false,
    onChange = null,
    willChange = null,
    duration = 5000,
    transition = 500,
    itemType = null,
    className = null,
}) {
    const [index, setIndex] = useState(initialIndex);
    const [nextIndex, setNextIndex] = useState(null);

    useEffect(() => {
        const id = setTimeout(() => {
            if (active) {
                setNextIndex((index + 1) % (items || []).length);
            }
        }, duration || 1000);
        return () => clearTimeout(id);
    }, [index, items, duration, active]);

    useEffect(() => {
        const id = setTimeout(() => {
            if (nextIndex !== null) {
                setIndex(nextIndex);
            }
        }, transition || 500);
        return () => clearTimeout(id);
    }, [setIndex, nextIndex, transition]);

    useEffect(() => {
        if (onChange !== null && items !== null && typeof items[index] !== 'undefined') {
            onChange(items[index]);
        }
    }, [index]);

    useEffect(() => {
        if (
            nextIndex !== null &&
            willChange !== null &&
            items !== null &&
            typeof items[nextIndex] !== 'undefined'
        ) {
            willChange(items[nextIndex]);
        }
    }, [nextIndex]);

    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <div className={styles.inner}>
                {(items || []).map((item, idx) => {
                    const { id = null, type = null } = item;
                    const Component = getComponentFromName(itemType || type, cards);
                    const current = index === idx;
                    return Component !== null ? (
                        <div
                            key={`carousel_${id}`}
                            className={styles.item}
                            style={{ opacity: current ? 1 : 0, zIndex: current ? 2 : 1 }}
                        >
                            <Component item={item} />
                        </div>
                    ) : null;
                })}
            </div>
        </div>
    );
}

Carousel.propTypes = propTypes;

export default Carousel;
